export const defaultThemeHooks = [
  "r4r-container",
  "r4r-home",
  "r4r__link--about",
  "browse-tiles__container",
  "browse__tile",
  "similar-resource__tile",
  "r4r-resource",
  "resource__main",
  "resource__back",
  "resource__nav",
  "resource__docs",
  "resource__access",
  "resource__link--external",
  "dummy-access-section",
  "similar-resource__container",
  "selected-filters__header",
  "selected-filters__filters-container",
  "selected-filters__filter",
  "r4r-results",
  "results__header",
  "results__selections-container",
  "results__count-container",
  "results__selected-filters",
  "results__main",
  "results__facets",
  "result-tile",
  "searchbar__container",
  "searchbar__button--submit",
  "r4r-pager",
  "r4r-pager__count",
  "r4r-pager__nav",
  "pager__num",
  "pager__arrow",
  "facet__box",
  "facet__title",
  "facet__filter",
  "contact-information",
  "filter-box__filter",
  "filter__checkbox",
  "filter__label",
  "r4r-boundary",
  "boundary__inner",
  "r4r-hidden",
  "results-container",
  "home__main",
  "home__desc",
  "home-nav",
  "home-nav__tiles",
  "home-nav__tile",
  "home-nav__main",
  "home-nav__section",
  "home-nav__title",
  "r4r-error",
  "resource__link--external",
  "r4r-resource__header",
  "resource__home",
  "r4r-svg-container",
  "home-tile__icon",
  "view-all__link",
  "results__search-container",
  "results__filter-button",
];
